// For usage not limited to svelte components
import type { ToastState } from './toast-state.svelte';

let _toast: ToastState | undefined;

export function initToasts(state: ToastState) {
  _toast = state;
}

function ensure() {
  if (!_toast) throw new Error('ToastState not initialized. Call initToasts() in your root component.');
  return _toast;
}

export function toast(opts: Parameters<ToastState['addToast']>[0]) {
  return ensure().addToast(opts);
}

export function removeToast(id: string) {
  return ensure().removeToast(id);
}